import React from "react";
import "./PaymentCancel.css";
import { Link } from "react-router-dom";

function PaymentCancel(props) {
	return(
		<div className="payment-cancel-wrapper">
			<div className="payment-cancel-container">
				<p>	You have cancelled upgrading to premium!</p>
				<Link to="/home">Back to Home</Link>
			</div>
		</div>
	)
}

export default PaymentCancel;
